module.exports = __webpack_public_path__ + "svg_80x80/qt.483395.svg";